module.exports = __webpack_public_path__ + "img/about-image-2.2f32c451.png";